import { FieldLabel, Flex, Text } from "@nulogy/components";
import HalfField from "components/common/HalfField";
import Input from "components/controls/Input";
import React from "react";
import styled from "styled-components";

const ProductionDetailField = styled(FieldLabel)`
  ${({ overrideValue, theme }) => overrideValue && `.field-value { color: ${theme.colors.grey}; }`}
`;

const PaddedFieldValue = styled.span(({ theme }) => ({
  display: "inline-block",
  fontSize: theme.fontSizes.small,
  padding: `${theme.space.x1} 0`,
}));

const StyledInput = styled(Input)`
  margin-bottom: 0 !important;
`;

export default function ProductionDetail({
  label,
  value,
  overrideValue,
  field,
  specClassName,
  disabled,
  additionalInfo,
  ...props
}) {
  return (
    <Flex gap="x2" {...props}>
      <HalfField>
        <ProductionDetailField className={specClassName} labelText={label} overrideValue={overrideValue}>
          <PaddedFieldValue>{value}</PaddedFieldValue>
        </ProductionDetailField>
      </HalfField>

      <HalfField>
        <Flex alignItems="end">
          <StyledInput
            className={`${specClassName}-override`}
            disabled={disabled}
            field={field}
            inputWidth="96px"
            labelText="Override"
            step="any"
            type="number"
          />
          {additionalInfo && (
            <Text fontSize="smaller" italic>
              <em>{additionalInfo || ""}</em>
            </Text>
          )}
        </Flex>
      </HalfField>
    </Flex>
  );
}
